<template>
  <div>
    <el-form class="login-container" label-position="left"
             label-width="0px">
      <h3 class="login_title">批量搭建账户录入平台</h3>
      <el-form-item>
        <el-input type="text" v-model="info.username"
                  auto-complete="off" placeholder="运营名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.twoname"
                  auto-complete="off" placeholder="二代名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.url"
                  auto-complete="off" placeholder="落地页链接"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.xiaoshuourl"
                  auto-complete="off" placeholder="点击监控链接"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.token"
                  auto-complete="off" placeholder="Token"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.ids"
                  auto-complete="off" placeholder="账户ID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.idsname"
                  auto-complete="off" placeholder="账户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="info.planName"
                  auto-complete="off" placeholder="计划名称"></el-input>
      </el-form-item>
      <el-button type="success" v-on:click="update">
        添加账户
      </el-button>

    </el-form>
    <el-table
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="list"
      id="exportTab"
      style="width: 100%">
      <el-table-column
        sortable
        prop="username"
        label="运营名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="twoname"
        label="二代名称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="url"
        label="落地页"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="xiaoshuourl"
        label="监控链接"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="token"
        label="token"
        width="180">
      </el-table-column>

      <el-table-column
        sortable
        prop="ids"
        label="广告主id"
        width="180">
      </el-table-column>

      <el-table-column
        prop="idsname"
        label="广告组名称"
        width="180">
      </el-table-column>
      <el-table-column
        sortable
        prop="planName"
        label="计划名称"
        width="180">
      </el-table-column>


    </el-table>




  </div>
</template>

<script>
export default {
  data() {
    return {
      list:[{
        username: '',
        twoname:'',
        url: '',
        xiaoshuourl: '',
        ids: '',
        idsname: '',
        planName: '',
        token:'',
      }],
      info:[{
        username: '',
        twoname:'',
        url: '',
        xiaoshuourl: '',
        ids: '',
        idsname: '',
        planName: '',
        token:'',
      }],
      values:'',
      level: [{
        value: 'SUBMIT',
        label: '表单提交'
      }, {
        value: 'REACTIVATION',
        label: '自定义拉活'
      }, {
        value: 'ACTIVATION',
        label: '自定义激活'
      },
        {
          value: 'PAY',
          label: '自定义付费'
        },
        {
          value: 'RETENTION_1',
          label: '自定义次留'
        }],
    }
  },
  methods: {

    //用户上报
    async update(){
      this.list.push(this.info)
      await this.$axios.post('https://test.nbweiou.cn/api/add_list_name',
        {
          'username':this.info.username,
          'twoname':this.info.twoname,
          'url':this.info.url,
          'xiaoshuourl':this.info.xiaoshuourl,
          'token':this.info.token,
          'ids':this.info.ids,
          'idsname':this.info.idsname,
          'planName':this.info.planName
        }).then(resp=>{
        // this.info.username='',
        //   this.info.twoname='',
        //   this.info.url='',
        //   this.info.xiaoshuourl='',
        //   this.info.token='',
        //   this.info.ids='',
        //   this.info.idsname='',
        //   this.info.planName='',
        // console.log(resp)
        }
      )


    },
  }
}
</script>

<style>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}
body{
  margin: 0px;
}
.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

</style>
<style scoped="scoped">
.btn-upload {
  z-index: 100;
  border-radius: 30px;
  box-shadow: 0 2px 12px 0 rgba(91, 156, 255, 0.9)
}

.el-upload {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/addInfoBatch.vue